import { Controller } from "@hotwired/stimulus";
import { handleHttpResponse } from "../../utils/http_utils";
import { closeModal, toggleClass } from "../../utils/misc";
import $ from "jquery";
import { originalResponseFromTurboResponseEvent } from "../../utils/turbo_utils";

export default class extends Controller {
  static targets = ["loader", "connectErrorMessage", "validConnectionIcon", "submitBtn"];

  onConnect() {
    if ($(this.submitBtnTarget.form).parsley().validate()) {
      this._toggleLoader();
      this._toggleErrorMessage(false);
    }
  }

  onConnectResponse(e) {
    handleHttpResponse({
      payload: originalResponseFromTurboResponseEvent(e),
      onSuccess: () => {
        this._setModalContent();
        setTimeout(() => {
          closeModal(this.element.id);
        }, 2000);
      },
      onError: () => {
        this._toggleErrorMessage(true);
      },
      onComplete: () => {
        this._toggleLoader();
      },
    });
  }

  _toggleLoader() {
    this.loaderTarget.classList.toggle("hidden");
  }

  _toggleErrorMessage(shouldDisplay) {
    toggleClass(this.connectErrorMessageTarget, "hidden", shouldDisplay);
  }

  _setModalContent() {
    this.validConnectionIconTarget.classList.remove("hidden");
    this.submitBtnTarget.classList.add("hidden");
  }
}
